const PromotionsBackend = {
  invoke: {
    startPromotions: async ([socketId, viewMode]: [string, string]) => {
      const { state } = await window.WH.bootstrapper!.features[
        'promotions-flow'
      ].getState();
      if (state !== 'STOPPED') {
        window.WH.bootstrapper!.features['promotions-flow'].stop();
      }
      return window.WH.bootstrapper!.features['promotions-flow'].start({
        containerSelector: `#${socketId}`,
        viewMode,
      });
    },
  },
};

export default PromotionsBackend;
